import { render, staticRenderFns } from "./trap_teams.vue?vue&type=template&id=d3997b74&"
import script from "./trap_teams.vue?vue&type=script&lang=js&"
export * from "./trap_teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports